import type { AppDescriptorDTO } from "../api/types.js";

/**
 * Bereiche, die zur Plattform gehören und keine eigenen Module sind.
 * Ihre Routen stehen in App.tsx; hier stehen sie, damit der Abgleich unten sie kennt.
 */
export const PLATFORM_ROUTES: readonly string[] = ["/", "/admin"];

/**
 * Apps, die der Server anbietet, für die es in dieser Oberfläche aber keine Seite gibt.
 *
 * Das kommt vor: die Registry im Backend und die Module hier sind zwei Listen, und ein
 * Modul kann serverseitig freigeschaltet sein, bevor die Oberfläche es kann — oder eine
 * ältere Oberfläche trifft auf ein neueres Backend. Ohne diese Prüfung landet ein
 * Klick auf das Symbol wortlos wieder auf der Startseite, und niemand weiß, warum.
 */
export function unimplementedApps(
  apps: readonly AppDescriptorDTO[],
  knownRoutes: readonly string[],
): AppDescriptorDTO[] {
  const known = new Set([...PLATFORM_ROUTES, ...knownRoutes]);
  return apps.filter((app) => !known.has(app.route));
}
